import { Table } from 'rsuite';

import './styles.css';

const { Cell } = Table;

/**
 * Custom Toggle component that applies the primary color of the custom theme to the checked state.
 * @component
 * @param {import('rsuite').CellProps} rest - Additional props to pass to the Toggle component.
 * @returns {JSX.Element} CustomToggle component.
 */

export function CustomCell({ children, ...rest }) {
  return (
    <Cell
      className="custom-cell"
      {...rest}
    >
      {children}
    </Cell>
  );
}
